import {Dialog as MUIDialog, DialogProps} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'

import {theme} from '../theme'
import DialogTransition from './DialogTransition'

const StyledDialog = withStyles(
  {
    container: {},
    paper: {
      margin: 0,
      [theme.breakpoints.down('sm')]: {
        borderRadius: 0,
        boxShadow: 'none',
      },
    },
    paperFullWidth: {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '100%',
      },
    },
    paperScrollPaper: {
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
        maxHeight: '100%',
      },
    },
  },
  {name: 'LPCDialogActions'},
)(MUIDialog)

const Dialog: React.FC<React.PropsWithChildren<DialogProps>> = props => {
  return (
    <StyledDialog TransitionComponent={props.TransitionComponent ?? DialogTransition} {...props}>
      {props.children}
    </StyledDialog>
  )
}

export default Dialog
